<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-heading">
            <h5>
                Paid Subscriptions
            </h5>
        </div>

        <loading-spinner v-if="loading" :style="loadingSpinnerStyle"></loading-spinner>

        <div v-else class="panel-body">
            <subscription-count-chart :year="year" :rows="rows" :loading="loading"></subscription-count-chart>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import moment from 'moment'
    import Chart from 'chart.js'
    import SaveHeight from '@/mixins/SaveHeight'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'
    import SubscriptionCountChart from '@/pages/Dashboards/Subscriptions/Panels/SubscriptionCount/SubscriptionCountChart'

    export default {
        components: {LoadingSpinner, SubscriptionCountChart},

        mixins: [SaveHeight],

        props: ['year', 'portal', 'user','subscriberType'],

        data() {
            return {
                loading: true,
                rows: null
            }
        },

        mounted() {
            this.load()
        },

        watch: {
            year() {
                this.load()
            },

            portal() {
                this.load()
            },

            user() {
                this.load()
            },

            subscriberType() {
                this.load()
            }
        },

        computed: {
            filters() {
                let filters = []

                if (this.portal && this.portal.length) {
                    filters.push({dimension: 'portal_id', operator: 'in', value: this.portal})
                }

                if (this.user) {
                    filters.push({dimension: 'user_id', value: this.user})
                }

                if (this.subscriberType) {
                    filters.push({dimension: 'subscriber_type', value: this.subscriberType})
                }

                return filters
            }
        },

        methods: {
            load() {
                this.saveHeight()

                this.loading = true

                this.getRowsPromise()
                    .then(response => {
                        this.rows = response.data.data

                        this.loading = false
                    })
            },

            getRowsPromise() {
                return http.post('/api/v1/reports/dashboard', {
                    start: moment().year(this.year).startOf('year').format('YYYY-MM-DD'),
                    end: moment().year(this.year).endOf('year').format('YYYY-MM-DD'),
                    metrics: ['subscription_month_count'],
                    dimensions: ['month'],
                    filters: this.filters
                })
            }
        }
    }
</script>
